'use client';
import React, { useState } from 'react';
import { toast } from 'sonner';
import { initialOrders, BaristaOrder, OrderStatus } from './baristaData';
import BaristaHeader from './BaristaHeader';
import BaristaStats from './BaristaStats';
import OrderColumn from './OrderColumn';
import OrderDetailModal from './OrderDetailModal';

export default function BaristaClient() {
  const [orders, setOrders] = useState<BaristaOrder[]>(initialOrders);
  const [selectedOrder, setSelectedOrder] = useState<BaristaOrder | null>(null);

  const yeni = orders.filter((o) => o.status === 'yeni');
  const hazirlaniyor = orders.filter((o) => o.status === 'hazirlaniyor');
  const hazir = orders.filter((o) => o.status === 'hazir');

  function advanceOrder(orderId: string) {
    setOrders((prev) =>
      prev.map((o) => {
        if (o.id !== orderId) return o;
        const next: OrderStatus = o.status === 'yeni' ? 'hazirlaniyor' : 'hazir';
        const label = next === 'hazirlaniyor' ? 'Hazırlanıyor' : 'Hazır';
        toast.success(`${o.orderNumber} → ${label}`, { description: o.customerName });
        return { ...o, status: next };
      })
    );
  }

  function completeOrder(orderId: string) {
    const order = orders.find((o) => o.id === orderId);
    if (!order) return;
    setOrders((prev) => prev.filter((o) => o.id !== orderId));
    toast.success(`${order.orderNumber} teslim edildi ✓`, { description: `${order.customerName} · ₺${order.totalPrice}` });
  }

  const todayCount = 42;
  const avgPrepTime = 4.2;

  return (
    <div className="min-h-screen barista-bg">
      <BaristaHeader />
      <BaristaStats
        todayCount={todayCount}
        avgPrepTime={avgPrepTime}
        activeOrders={yeni.length + hazirlaniyor.length}
        readyOrders={hazir.length}
      />

      {/* Kanban columns */}
      <div className="px-3 pb-6 overflow-x-auto">
        <div className="flex gap-3 min-w-max">
          <OrderColumn
            title="Yeni Sipariş"
            status="yeni"
            orders={yeni}
            count={yeni.length}
            color="text-amber-400"
            dotColor="bg-amber-400"
            onAdvance={advanceOrder}
            onComplete={completeOrder}
            onSelect={setSelectedOrder}
          />
          <OrderColumn
            title="Hazırlanıyor"
            status="hazirlaniyor"
            orders={hazirlaniyor}
            count={hazirlaniyor.length}
            color="text-blue-400"
            dotColor="bg-blue-400"
            onAdvance={advanceOrder}
            onComplete={completeOrder}
            onSelect={setSelectedOrder}
          />
          <OrderColumn
            title="Hazır"
            status="hazir"
            orders={hazir}
            count={hazir.length}
            color="text-green-400"
            dotColor="bg-green-400"
            onAdvance={advanceOrder}
            onComplete={completeOrder}
            onSelect={setSelectedOrder}
          />
        </div>
      </div>

      {selectedOrder && (
        <OrderDetailModal
          order={selectedOrder}
          onClose={() => setSelectedOrder(null)}
          onAdvance={advanceOrder}
          onComplete={completeOrder}
        />
      )}
    </div>
  );
}